"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bortigiadas": {
    "93914e8a": [{
      "hkey": "050b1820",
      "slug": "figaruia",
      "name": "Figaruia",
      "primary": true,
      "skipSearch": false
    }],
    "figaruja": [{
      "hkey": "050b1820",
      "slug": "figaruia",
      "name": "Figaruia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "002993c6": [{
      "hkey": "049033e5",
      "slug": "bortigiadas",
      "name": "Bortigiadas",
      "primary": true,
      "skipSearch": false
    }],
    "li-pauli": [{
      "hkey": "049033e5",
      "slug": "bortigiadas",
      "name": "Bortigiadas",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd5be157": [{
      "hkey": "049033e5",
      "slug": "bortigiadas",
      "name": "Bortigiadas",
      "primary": true,
      "skipSearch": false
    }],
    "tisiennari": [{
      "hkey": "049033e5",
      "slug": "bortigiadas",
      "name": "Bortigiadas",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;